import { FC } from 'react'
import {
  DropDownList,
  DropDownListChangeEvent,
  DropDownListProps
} from '@progress/kendo-react-dropdowns'

import Constants from '../../data/Constants.json'

const codeNames = Constants.outputYears

interface OutputYearsDropDownListProps
  extends Omit<
  DropDownListProps,
  'data' | 'dataItemKey' | 'textField' | 'onChange'
  > {
  /** code */
  defaultValue?: string
  /** code */
  value?: string
  /**
   * @param value code
   */
  onChange?: (value: string) => void
}

export const OutputYearsDropDownList: FC<OutputYearsDropDownListProps> = ({
  defaultValue,
  value,
  onChange,
  ...restProps
}) => {
  const createValue = (codeValue?: string) => {
    if (codeValue === undefined) {
      return null
    }

    const value = codeNames.find((codeName) => codeName.code === codeValue)

    return value === undefined ? null : value
  }

  const handleOnChange = (event: DropDownListChangeEvent) => {
    onChange?.(event.value.code)
  }

  return (
    <DropDownList
      {...restProps}
      data={codeNames}
      dataItemKey="code"
      textField="name"
      defaultValue={createValue(defaultValue)}
      value={createValue(value)}
      onChange={handleOnChange}
    />
  )
}
